export default "__VITE_ASSET__CF51RMDW__"